/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespComplementaryItemsGrid_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_viewer">;
    readonly " $refType": "PdpRespComplementaryItemsGrid_viewer";
};
export type PdpRespComplementaryItemsGrid_viewer$data = PdpRespComplementaryItemsGrid_viewer;
export type PdpRespComplementaryItemsGrid_viewer$key = {
    readonly " $data"?: PdpRespComplementaryItemsGrid_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespComplementaryItemsGrid_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespComplementaryItemsGrid_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '64a3ea2779157c349a659e1aa0dcd062';
export default node;
